require([
  'basicRecommendedModal',
  'basicThankYouModal',
  'ajaxHelper',
  'lazyLoad',
  'gallery',
  'windowModal',
  'leadModal',
  'domHelper',
  'load-mortgage',
  'eventLogger',
  'vanillaMasker',
  'favoritesInit',
  'handlerTrustedForm',
  'getPreApprovedLoader',
  'setupBasicInheritedProperties',
  'recommendationEvents',
  'guidGenerator',
  'prefillForm',
], (
  basicRecommendedModal,
  basicThankYouModal,
  ajaxHelper,
  lazyLoad,
  gallery,
  windowModal,
  leadModal,
  domHelper,
  loadMortgage,
  EventLogger,
  vanillaMasker,
  saveToFavorites
) => {
  'use strict';

  const eventLogger = new EventLogger();

  window.jQuery.googlepush = eventLogger.googlepush;
  const mainForm = document.querySelector('[data-form]');

  function setEmailSuggestionsEngine() {
    const loadEmailSuggestions = function () {
      if (!window.Mailcheck) {
        require(['emailDomainValidator']);
      }
      this.removeEventListener('focusin', loadEmailSuggestions);
    };
    mainForm.addEventListener('focusin', loadEmailSuggestions);
  }

  /**
   * Sets the Number Reveal behavior for Contact Agent and Broker phones.
   * @param {Object} btnElement button element selected.
   */
  function logAgentPhoneNumberReveal(btnElement) {
    const seePhoneNumberBtn = btnElement.firstChild;
    const agentPhoneNumber = btnElement.lastChild;
    const eventFromPage = 'BLPNV';
    const logInfo = JSON.parse(document.getElementById('LogInformation').value);

    if (seePhoneNumberBtn && agentPhoneNumber) {
      seePhoneNumberBtn.setAttribute('hidden', '');
      agentPhoneNumber.removeAttribute('hidden');
      eventLogger.logEvent(eventFromPage, logInfo.CommunityId, logInfo.BuilderId, logInfo.PartnerId, logInfo.SpecId);
    }

    return false;
  }

  const phoneInput = document.querySelector('[data-phone-input]');
  vanillaMasker(phoneInput).maskPattern('(999) 999-9999');

  const agentPhoneNumbers = document.querySelectorAll('[data-reveal-phone]');
  if (agentPhoneNumbers) {
    agentPhoneNumbers.forEach((element) => {
      element.addEventListener('click', function () {
        logAgentPhoneNumberReveal(this);
      });
    });
  }

  window.windowModal = windowModal;
  if (!window.NHS || !window.NHS.Scripts) {
    window.NHS = {
      Scripts: {},
    };
  }
  window.NHS.Scripts.LeadModal = leadModal;

  // Used to GET the image gallery if there's images
  (function () {
    function initGallery() {
      if (document.getElementById('nhs_DetailGalleryMain')) {
        const images = JSON.parse(document.getElementById('nhs_DetailGalleryMain').dataset.imagelist);
        const mainImage = document.querySelector('#GalleryImage[data-src]');
        if (mainImage) {
          mainImage.src = mainImage.dataset.src;
        }
        setupGallery(images);
      }
    }

    if (document.readyState === 'complete') {
      initGallery();
    } else {
      window.addEventListener('load', initGallery);
    }
  })();

  function setupGallery(images) {
    const imageList = [];

    for (let image = 0; image < images.length; image++) {
      imageList.push({ url: images[image].Path, alt: images[image].Caption || '' });
    }

    const galleryContainer = document.querySelector('#gallery');
    window.imageGallery = new galleryInit(galleryContainer, imageList);

    window.imageGallery.onChange = function (index) {
      document.querySelector('.nhs_DetailTileBottom span').innerHTML =
        index + 1 + '/' + window.imageGallery.images.length;
    };
  }

  // Scroll to top functionality

  const scrollToTopItems = document.querySelectorAll("[href='#top']");

  for (let i = 0; i < scrollToTopItems.length; i++) {
    scrollToTopItems[i].addEventListener('click', (event) => {
      if (window.scroll) {
        event.preventDefault();
        window.scroll({ top: 0, left: 0, behavior: 'smooth' });
      }
    });
  }

  // Open the map & directions section

  (function () {
    const mapContainer = document.querySelector('[data-map-container]');

    if (!mapContainer) {
      return;
    }

    const mapSection = document.getElementById('dd-collapsible');
    const openMapButton = document.getElementById('nhs_propertyMapCollapsibleOpen');
    const closeMapButton = document.getElementById('nhs_propertyMapCollapsibleClose');

    openMapButton.addEventListener('mousedown', (event) => {
      event.preventDefault();
      mapSection.style.display = 'block';
      openMapButton.style.display = 'none';
      closeMapButton.style.display = 'block';

      require(['basicCommunitiesMaps'], (mapSection) => {
        mapSection.init();
      });
    });

    closeMapButton.addEventListener('mousedown', (event) => {
      event.preventDefault();
      mapSection.style.display = 'none';
      openMapButton.style.display = 'block';
      closeMapButton.style.display = 'none';
    });
  })();

  // Lazy Loading
  (function () {
    function lazyLoadSection(entry) {
      // to make sure it works without interSectionObserver
      if (entry.target) {
        entry = entry.target;
      }
      const url = location.protocol + '//' + location.hostname + entry.attributes.url.value;

      ajaxHelper.getRequest(url, null, null, {
        async: true,
        success(response) {
          entry.innerHTML = response;
          lazyLoad.init();
          saveToFavorites.init();
        },
      });
    }

    lazyLoad.init();

    const lazyLoadSections = document.querySelectorAll('.nhs_lazyLoadSection');

    var rootMarginObserver = new IntersectionObserver(
      (entries) => {
        for (let i = 0; i < entries.length; i++) {
          if (entries[i].intersectionRatio <= 0 || !entries[i]) {
            return;
          }

          lazyLoadSection(entries[i]);

          // stop observing the section once it's been loaded
          rootMarginObserver.unobserve(entries[i].target);
        }
      },
      { root: null, rootMargin: '800px 0px' }
    );

    // lazy load the sections
    for (let i = 0; i < lazyLoadSections.length; i++) {
      rootMarginObserver.observe(lazyLoadSections[i]);
    }
  })();

  /**
   * Handles click events on the "Show More/Show Less" buttons
   * @param {Event} event - Click event on the "Show More/Show Less" toggle
   */
  function showMoreClickHandler(event) {
    const target = event.target;
    const container = target.closest('[data-legal-text-container]');

    if (!container) {
      return;
    }

    const truncated = container.classList.toggle('form__legal--truncated');
    target.textContent = truncated ? 'Show More' : 'Show Less';
  }

  // Show more legal disclaimer behavior
  (function () {
    const showMoreButtons = document.querySelectorAll('[data-legal-text-toggle]');
    showMoreButtons.forEach((showMoreButton) => {
      showMoreButton.addEventListener('click', showMoreClickHandler);
    });
  }());

  setEmailSuggestionsEngine();
  loadMortgage.init();
});

define("nhs/views/BasicHomeDetail/ShowBasicDetail", function(){});

